<template>
	<div
		class="tab-items"
		:class="{ 'tab-items--padded': pad, 'tab-items--border': border }"
	>
		<slot></slot>
	</div>
</template>

<script>
/**
Wraps tab items:
 - determines which is active via the tab property
 - provides some style controls
*/
export default {
	name: 'TabItems',
	props: {
		border: {
			type: Boolean,
			default: true,
		},
		pad: {
			type: Boolean,
			default: true,
		},
		tab: {
			type: String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
.tab-items {
	&--padded {
		padding: $b360-spacing-base;
	}
}
</style>
